const messages = {
  step3: {
    actionBtn: "Accedi",
  },
};

export default {
  messages,
};
